import { render, staticRenderFns } from "./searchBox.vue?vue&type=template&id=113924ba&scoped=true&"
import script from "./searchBox.vue?vue&type=script&lang=ts&"
export * from "./searchBox.vue?vue&type=script&lang=ts&"
import style0 from "./searchBox.vue?vue&type=style&index=0&id=113924ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113924ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Users\\its_bas_sp_schramwy\\serviceportal\\RUB.Serviceportal\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('113924ba', component.options)
    } else {
      api.reload('113924ba', component.options)
    }
    module.hot.accept("./searchBox.vue?vue&type=template&id=113924ba&scoped=true&", function () {
      api.rerender('113924ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/searchBox.vue"
export default component.exports